import { render } from "./RegistrationPending.vue?vue&type=template&id=0dfc56b3&scoped=true&lang=pug"
import script from "./RegistrationPending.vue?vue&type=script&lang=js"
export * from "./RegistrationPending.vue?vue&type=script&lang=js"

import "./RegistrationPending.vue?vue&type=style&index=0&id=0dfc56b3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfc56b3"]])

export default __exports__